import Vue from "vue";
import * as filtroTomador from './filtroTomador';
import * as filtroCooperado from './filtroCooperado';
import * as zplConnect from './printer/zplConnect';
import store from '@/store'

const converteReal = (value, trocarZero = false) => {
  var valueAux = parseFloat(value);
  if (valueAux == 0 && trocarZero) {
    return "-";
  }
  if (Number.isFinite(valueAux)) {
    var valorFormatado = valueAux.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    return valorFormatado
  }
  return "-"
}

const converteKM = (value) => {
  if (value) {
    var stringParaFloat = parseFloat(value)
    var valorFormatado = stringParaFloat.toLocaleString({ style: 'decimal' });
    return valorFormatado
  }
  return "-"
}

const converteData = (value) => {
  if (value) {
    var dataFormatada = "";
    dataFormatada = value.replace(/-/g, "/").substr(-20, 10)
      .split('/').reverse().join('/');
    return dataFormatada
  }
  return "-"
}


const converteDataHora = (value) => {
  if (value) {
    const anoMesDia = value.substr(0, 10).split('-');
    const horaMinSeg = value.substr(11, 8).split(':');

    const dataFormatada = `${anoMesDia[2]}/${anoMesDia[1]}/${anoMesDia[0]} ${horaMinSeg[0]}:${horaMinSeg[1]}:${horaMinSeg[2]}`;
    return dataFormatada;
  }
  return "-";
}
const reducer = (previousValue, currentValue) => parseFloat(previousValue) + parseFloat(currentValue);

const base64toBlob = (b64Data) => {
  var sliceSize = 512;

  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, { type: 'application/pdf' });
  return blob;
}

const alerta = (mensagem, icone) => {
  Vue.swal({
    position: "top-end",
    icon: icone,
    title: mensagem,
    showConfirmButton: false,
    timer: 4000
  });
}

const erroPlaca = (mensagem) => {
  Vue.swal({
    position: "top-end",
    icon: "error",
    title: mensagem,
    showConfirmButton: false,
  });
}

const alertaConfirm = (title) => {
  return new Promise((resolve, reject) => {
    Vue.swal({
      title: title,
      showDenyButton: true,
      denyButtonText: 'Não',
      confirmButtonText: 'Sim',
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#f46a6a",
    }).then((result) => {
      if (result.isConfirmed) {
        resolve(true);
      } else if (result.isDenied) {
        reject(false);
      }
    });
  });
}


var menuAux = true;
const menu = () => {
  document.body.classList.toggle("vertical-collpsed");
  menuAux = !menuAux
  if (menuAux) {
    document.body.classList.remove("sidebar-enable");
    // document.body.classList.remove("vertical-collpsed");
  } else {
    document.body.classList.add("sidebar-enable");
    // document.body.classList.add("vertical-collpsed");
  }
}

const abrirMenu = () => {
  document.body.classList.toggle("vertical-collpsed");
  menuAux = true;
  document.body.classList.remove("sidebar-enable");
  document.body.classList.remove("vertical-collpsed");
}

const fecharMenu = () => {
  if (window.innerWidth <= 768) {
    document.body.classList.remove("vertical-collpsed");
    document.body.classList.remove("sidebar-enable");
  } else {
    document.body.classList.add("vertical-collpsed");
  }
  menuAux = false;
}

const diaSemana = (dia) => {
  var semana = ["Domingo", "Segunda-Feira", "Terça-Feira", "Quarta-Feira", "Quinta-Feira", "Sexta-Feira", "Sábado"];
  return semana[dia];
}

const diaSemanaAbrev = (dia) => {
  var semana = ["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SÁB"];
  return semana[dia];
}

const mesesDoAno = (mes) => {
  var meses = [
    "",
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro"
  ]
  return meses[mes]
}

const statusDespesa = (value) => {
  var status = {
    'A': 'Aprovado',
    'B': 'Bloqueado',
    'L': 'Liberado',
    'P': 'Pendente',
    'R': 'Rejeitado',
    'E': 'Pré-aprovado',
    'J': 'Pré-rejeitado'
  }
  return status[value];
}

const getBrowser = () => {
  var
    aKeys = ["MSIE", "Firefox", "Safari", "Chrome", "Opera"],
    sUsrAg = window.navigator.userAgent, nIdx = aKeys.length - 1,
    retorno = "";

  for (nIdx; nIdx > -1 && sUsrAg.indexOf(aKeys[nIdx]) === -1; nIdx--);
  try {
    retorno = sUsrAg.substr(sUsrAg.indexOf(aKeys[nIdx]), 16).split("/");
    return retorno;
  } catch (err) {
    return ['', ''];
  }

}

const getIp = () => {
  fetch("https://api.ipify.org?format=json")
    .then((x) => x.json())
    .then(({ ip }) => {
      store.commit('SET_IP', ip);
    });
}

const viewDebug = (tipo = "", dados) => {
  if (store.state.debug) {
    console.log(tipo, dados);
  }
}

const criarGraficoDespesas = (retorno) => {
  var aux = [];
  var nomeDespesa = [];
  var auxSoma = 0;
  var informacoes = [];
  retorno.forEach((el) => {
    if (el.st_lancamento != 'NV') {
      if (!aux.includes(el.cd_norma)) {
        aux.push(el.cd_norma);
        if (el.vl_lancamento === 0) { return }
        nomeDespesa[aux.indexOf(el.cd_norma)] = {
          nome: el.ds_norma,
          valor: parseFloat(el.vl_lancamento),
          categoria: el.ds_categoria_norma,
          icone: el.ds_icone_web,
          cor: el.ds_cor_web
        }
      } else {
        nomeDespesa[aux.indexOf(el.cd_norma)].valor += parseFloat(el.vl_lancamento)
      }
    }
  });
  nomeDespesa.forEach((el, key) => {
    auxSoma += parseFloat(nomeDespesa[key].valor)
    nomeDespesa[key].valor = parseFloat(nomeDespesa[key].valor.toFixed(2))
  });
  nomeDespesa = nomeDespesa.sort((a, b) => {
    if (a.valor < b.valor) {
      return 1;
    } else {
      return -1;
    }
  });
  informacoes.norma = nomeDespesa;
  informacoes.soma = auxSoma.toFixed(2);
  return informacoes;
}

const corBadge = (el) => {
  switch (el) {
    case "A":
      return 'badge-soft-success';
    case "L":
      return 'badge-soft-primary';
    case "R":
      return 'badge-soft-danger';
    case "J":
      return 'badge-soft-secondary';
    case "P":
      return 'badge-soft-warning';
    case "E":
      return 'badge-soft-info';
    case "NV":
      return 'badge-soft-danger';

    default:
      break;
  }
}

const converterCnpj = (param) => {
  return param.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

const validarCPF = (cpf) => {
  cpf = cpf.replace(/[^\d]+/g, ''); // Remove caracteres não numéricos
  // Verifica se a quantidade de dígitos numéricos é igual a 11
  if (cpf.length !== 11) {
    return false;
  }
  // Verifica se todos os dígitos são iguais (ex: 111.111.111-11)
  var isRepeating = true;
  for (var i = 0; i < 10; i++) {
    if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
      isRepeating = false;
      break;
    }
  }
  if (isRepeating) {
    return false;
  }
  // Calcula o primeiro dígito verificador
  var soma = 0;
  for (var b = 0; b < 9; b++) {
    soma += parseInt(cpf.charAt(b)) * (10 - b);
  }
  var resto = 11 - (soma % 11);
  var digito1 = resto === 10 || resto === 11 ? 0 : resto;
  // Calcula o segundo dígito verificador
  soma = 0;
  for (var c = 0; c < 10; c++) {
    soma += parseInt(cpf.charAt(c)) * (11 - c);
  }
  resto = 11 - (soma % 11);
  var digito2 = resto === 10 || resto === 11 ? 0 : resto;
  // Verifica se os dígitos verificadores são iguais aos dígitos informados
  if (digito1 !== parseInt(cpf.charAt(9)) || digito2 !== parseInt(cpf.charAt(10))) {
    return false;
  }
  return true;
}

const validarEmail = (email) => {
  var usuario = email.substring(0, email.indexOf("@"));
  var dominio = email.substring(email.indexOf("@") + 1, email.length);

  if ((usuario.length >= 1) &&
    (dominio.length >= 3) &&
    (usuario.search("@") == -1) &&
    (dominio.search("@") == -1) &&
    (usuario.search(" ") == -1) &&
    (dominio.search(" ") == -1) &&
    (dominio.search(".") != -1) &&
    (dominio.indexOf(".") >= 1) &&
    (dominio.lastIndexOf(".") < dominio.length - 1)) {
    return true
  } else {
    return false
  }
}
function calcularDiferencaDatas(data1, data2) {
  var diferencaEmAnos = data2.getFullYear() - data1.getFullYear();
  var diferencaEmMeses = data2.getMonth() - data1.getMonth();
  var diferencaEmDias = data2.getDate() - data1.getDate();

  // Verifica se a diferença em meses é negativa e ajusta os anos
  if (diferencaEmMeses < 0) {
    diferencaEmAnos--;
    diferencaEmMeses += 12;
  }

  // Verifica se a diferença em dias é negativa e ajusta os meses e anos
  if (diferencaEmDias < 0) {
    diferencaEmMeses--;
    var ultimoDiaMesAnterior = new Date(data2.getFullYear(), data2.getMonth(), 0).getDate();
    diferencaEmDias += ultimoDiaMesAnterior;
  }

  return {
    anos: diferencaEmAnos,
    meses: diferencaEmMeses,
    dias: diferencaEmDias
  };
}

function calcularIdade(dataNascimento) {
  const dataNascimentoParte = dataNascimento.substr(0, 10);
  const [ano, mes, dia] = dataNascimentoParte.split('-');
  const dataNascimentoObj = new Date(ano, mes - 1, dia); // O mês em JavaScript é indexado a partir de 0
  const dataAtual = new Date();
  const diferenca = dataAtual - dataNascimentoObj;
  const idade = Math.floor(diferenca / (1000 * 60 * 60 * 24 * 365.25));
  return idade;
}

export {
  converteReal,
  converteData,
  converteDataHora,
  reducer,
  base64toBlob,
  alerta,
  menu,
  fecharMenu,
  diaSemana,
  erroPlaca,
  diaSemanaAbrev,
  filtroTomador,
  filtroCooperado,
  zplConnect,
  statusDespesa,
  mesesDoAno,
  getBrowser,
  getIp,
  abrirMenu,
  converteKM,
  viewDebug,
  criarGraficoDespesas,
  alertaConfirm,
  corBadge,
  converterCnpj,
  validarCPF,
  validarEmail,
  calcularDiferencaDatas,
  calcularIdade
} 